import React from "react";

interface SicoobLogoProps extends React.SVGProps<SVGSVGElement> {
    width?: string | number;
    height?: string | number;
}

export const SicoobLogo: React.FC<SicoobLogoProps> = ({
    width = 110,
    height = 70,
    color = "#013E45",
    ...props
}) => {

    const AdjustedViewBox = "-10 0 1740 417";

    return (
        <svg
            {...props}
            version="1.1"
            id="Layer_1"
            viewBox={AdjustedViewBox}
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
        >
            {/* --- TODO O SEU SVG ORIGINAL AQUI, SEM ALTERAR NADA --- */}
            {/* Basta colar exatamente o conteúdo bruto abaixo */}


            <path fill="#013E45" opacity="1.000000" stroke="none"
                d="
M1720.000000,265.531372 
	C1716.086914,273.410522 1712.937988,281.367004 1708.110840,288.124634 
	C1695.790527,305.372284 1677.798950,314.102020 1657.748413,318.951355 
	C1626.703735,326.459656 1595.096313,326.806671 1563.445435,325.422546 
	C1550.334961,324.849213 1537.277466,323.114075 1524.184448,322.048523 
	C1521.395630,321.821564 1520.290039,320.691467 1520.576294,317.975037 
	C1520.680542,316.986481 1520.592041,315.977692 1520.592041,314.978119 
	C1520.591919,235.846222 1520.592041,156.714340 1520.592041,77.582451 
	C1520.592041,75.604172 1520.592041,73.625900 1520.592041,70.934479 
	C1527.504395,70.005692 1534.171021,68.819450 1540.889648,68.256325 
	C1573.948730,65.485504 1607.044312,63.843727 1640.163818,67.112167 
	C1654.991211,68.575424 1669.253540,72.298492 1682.420288,79.561592 
	C1702.447998,90.609161 1713.603394,107.427605 1713.664795,130.419418 
	C1713.724854,152.913513 1702.054688,168.656982 1682.710938,179.153641 
	C1679.379028,180.961655 1675.896240,182.491455 1671.734375,184.513580 
	C1695.047485,191.854141 1712.170166,204.971115 1719.733154,228.760681 
	C1720.000000,241.020889 1720.000000,253.041794 1720.000000,265.531372 
M1593.006592,275.628326 
	C1606.157471,276.114349 1619.362061,276.928162 1631.872314,271.538239 
	C1644.382202,266.148529 1650.365356,256.396820 1650.018677,242.296387 
	C1649.740845,231.001083 1642.955200,222.506561 1630.455444,217.933990 
	C1616.828003,212.948898 1602.703369,214.072479 1588.644531,214.176712 
	C1588.415405,215.077774 1588.193970,215.542862 1588.193359,216.008209 
	C1588.169312,234.653290 1588.242432,253.299026 1588.085938,271.942871 
	C1588.058716,275.183044 1589.846069,275.374207 1593.006592,275.628326 
M1610.523926,165.064041 
	C1617.117310,163.576904 1624.016113,162.868561 1630.236572,160.430099 
	C1641.044067,156.193436 1645.858276,147.566437 1645.038086,136.452988 
	C1644.339111,126.983498 1638.054199,119.853539 1627.175903,116.853813 
	C1614.424927,113.337700 1601.544678,114.563179 1588.463379,116.128113 
	C1588.463379,132.642471 1588.463379,148.821671 1588.463379,165.096619 
	C1595.712036,165.096619 1602.657104,165.096619 1610.523926,165.064041 
z"/>
            <path fill="#75C044" opacity="1.000000" stroke="none"
                d="
M119.988403,236.216583 
	C109.872696,218.849823 99.681618,201.526443 89.655685,184.108002 
	C61.791622,135.698593 34.000092,87.247429 6.163515,38.822182 
	C4.588565,36.082355 2.866468,33.427116 1.106428,30.366253 
	C1.000000,27.299986 1.000000,24.599974 1.096492,21.080761 
	C1.781826,19.807669 2.722349,19.465036 2.906462,18.883095 
	C5.440404,10.873860 10.658879,5.590759 18.606791,2.894084 
	C19.514275,2.586180 20.207453,1.646657 21.000000,1.000000 
	C74.354225,1.000000 127.708458,1.000000 181.252151,1.242803 
	C181.562622,1.700559 181.683624,1.915513 181.886261,2.474776 
	C185.329834,8.730300 188.694931,14.639712 192.053055,20.553074 
	C200.815948,35.983761 209.575775,51.416176 218.208694,67.204453 
	C212.703430,76.911896 207.326050,86.262634 201.949265,95.613724 
	C187.310089,121.073547 172.671143,146.533508 157.765594,172.203522 
	C149.381729,186.487335 141.322021,200.594757 133.123230,214.620865 
	C128.871994,221.893692 124.374596,229.022644 119.988403,236.216583 
z"/>
            <path fill="#01AE9D" opacity="1.000000" stroke="none"
                d="
M218.336838,66.847900 
	C209.575775,51.416176 200.815948,35.983761 192.053055,20.553074 
	C188.694931,14.639712 185.329834,8.730300 182.371582,2.423722 
	C257.687317,2.018993 332.599426,2.016716 407.511475,1.958455 
	C409.341217,1.957032 411.170502,1.333419 413.000000,0.999999 
	C414.066681,1.000000 415.133331,1.000000 416.600006,1.000003 
	C418.365997,1.948685 419.627716,3.122540 421.114288,3.810781 
	C434.149292,9.845552 439.238617,24.414776 432.096039,36.905052 
	C406.346252,81.933838 380.409729,126.855865 353.794312,171.960434 
	C328.414764,172.031494 303.784698,171.960327 279.069458,171.548218 
	C262.031128,141.815369 245.094955,112.413635 228.109314,83.040504 
	C224.953934,77.583923 221.599442,72.242477 218.336838,66.847900 
z"/>
            <path fill="#0E0E0E" opacity="1.000000" stroke="none"
                d="
M412.531342,0.999999 
	C411.170502,1.333419 409.341217,1.957032 407.511475,1.958455 
	C332.599426,2.016716 257.687317,2.018993 182.289917,2.079412 
	C181.683624,1.915513 181.562622,1.700559 181.720810,1.242803 
	C258.687561,1.000000 335.375122,1.000000 412.531342,0.999999 
z"/>
            <path fill="#ffffff" opacity="1.000000" stroke="none"
                d="
M20.530956,1.000000 
	C20.207453,1.646657 19.514275,2.586180 18.606791,2.894084 
	C10.658879,5.590759 5.440404,10.873860 2.906462,18.883095 
	C2.722349,19.465036 1.781826,19.807669 1.096492,20.630781 
	C1.000000,14.407272 1.000000,7.814544 1.000000,1.000000 
	C7.352261,1.000000 13.707088,1.000000 20.530956,1.000000 
z"/>
            <path fill="#013E45" opacity="1.000000" stroke="none"
                d="
M1418.592773,69.318741 
	C1463.048706,84.517113 1487.663452,116.554428 1496.772705,160.941864 
	C1503.878174,195.566101 1500.800781,229.683319 1485.211304,261.822723 
	C1467.514648,298.306427 1437.425659,318.376404 1397.951294,324.991547 
	C1374.963745,328.843872 1352.111572,328.015503 1329.885498,320.582153 
	C1296.813110,309.521362 1273.474243,287.422882 1260.735107,255.216125 
	C1243.008301,210.399750 1244.383911,165.806061 1268.072754,123.403946 
	C1288.268188,87.255165 1320.484619,68.333900 1361.422363,63.892380 
	C1380.715576,61.799191 1399.636475,63.663914 1418.592773,69.318741 
M1327.328857,234.031021 
	C1329.902466,239.417099 1331.964966,245.126923 1335.136963,250.134033 
	C1350.036987,273.654785 1380.399536,280.126221 1401.571655,264.474609 
	C1411.136841,257.403473 1417.061035,247.662582 1421.001587,236.643784 
	C1427.866211,217.449173 1429.105591,197.632721 1426.640259,177.589005 
	C1424.795288,162.588013 1420.472534,148.333786 1411.187744,136.022217 
	C1393.567017,112.657349 1360.730713,110.579628 1341.789307,132.213211 
	C1336.430786,138.333374 1331.957031,145.803772 1329.073730,153.411469 
	C1319.126709,179.656448 1319.377808,206.442413 1327.328857,234.031021 
z"/>
            <path fill="#013E45" opacity="1.000000" stroke="none"
                d="
M997.849243,118.872452 
	C1026.014160,76.596802 1066.204834,60.495476 1115.240479,63.608826 
	C1140.447266,65.209236 1163.436035,73.221878 1183.102661,89.463303 
	C1205.902466,108.292152 1218.884521,132.963455 1224.265381,161.639542 
	C1230.320312,193.907196 1228.208618,225.692108 1215.188965,256.100464 
	C1198.429932,295.242462 1167.985718,317.467712 1126.571777,324.803284 
	C1100.395020,329.439911 1074.395142,328.082703 1049.561279,317.768738 
	C1015.862000,303.772675 994.291565,278.345306 983.911987,243.829330 
	C970.892944,200.536057 974.367004,158.669174 997.849243,118.872452 
M1093.775024,118.012573 
	C1080.963501,120.505310 1071.088135,127.533165 1064.149536,138.334549 
	C1060.496826,144.020844 1057.326538,150.207153 1055.079468,156.570602 
	C1048.295776,175.780838 1047.555664,195.670074 1050.342285,215.668915 
	C1052.265259,229.469955 1056.473145,242.565155 1065.005737,253.909882 
	C1080.030396,273.886383 1107.902588,278.979126 1127.703857,265.305145 
	C1137.669922,258.422913 1143.851196,248.668915 1148.003906,237.540909 
	C1154.648315,219.736130 1156.071167,201.270187 1154.463013,182.491241 
	C1153.140747,167.051010 1149.489990,152.270081 1140.749146,139.210083 
	C1129.754639,122.782562 1114.539307,115.182602 1093.775024,118.012573 
z"/>
            <path fill="#013E45" opacity="1.000000" stroke="none"
                d="
M459.510254,255.841095 
	C461.212769,255.961029 462.787415,256.269897 464.225189,256.894104 
	C486.998291,266.781464 510.605133,272.341766 535.561401,269.892334 
	C540.746521,269.383423 546.145630,267.930634 550.785706,265.598755 
	C562.906921,259.507263 564.801514,244.541611 553.954895,236.465576 
	C546.760681,231.109009 538.198242,227.249313 529.761230,223.974380 
	C512.833862,217.403809 495.737793,211.334564 480.795441,200.662598 
	C465.411316,189.675110 453.571503,176.039917 450.036255,156.868118 
	C444.149231,124.942307 458.212097,95.649918 487.157440,78.902031 
	C507.505127,67.128792 529.789185,63.130169 552.917419,63.721157 
	C562.494751,63.965878 572.277100,64.938202 581.532898,67.286911 
	C604.361572,73.079773 614.612732,89.481232 610.777527,112.773811 
	C609.763245,118.933830 607.830688,124.942642 606.240784,131.338394 
	C589.822449,124.478386 573.581909,120.534218 556.675659,119.485214 
	C547.630737,118.923996 538.681274,119.270187 530.151550,122.802490 
	C523.736938,125.458931 519.087769,129.727875 518.436951,137.033569 
	C517.793762,144.252686 521.628601,149.478485 527.637268,152.332840 
	C539.472961,157.955231 551.831604,162.476318 563.670166,168.093246 
	C576.245422,174.059662 589.267334,179.592911 600.702515,187.363297 
	C642.803650,215.971603 637.893127,277.324158 601.941956,304.223450 
	C586.470886,315.799225 568.917542,321.978271 550.126587,324.728699 
	C517.949219,329.438507 486.445984,326.284882 455.844391,315.102203 
	C446.748810,311.778442 446.788849,311.653748 448.884155,302.367676 
	C452.358521,286.969818 455.840179,271.573639 459.510254,255.841095 
z"/>
            <path fill="#BFD731" opacity="1.000000" stroke="none"
                d="
M279.154602,171.889160 
	C303.784698,171.960327 328.414764,172.031494 353.506958,172.164795 
	C346.338867,185.685928 338.790833,199.192307 331.063934,212.595551 
	C300.697327,265.270111 270.284729,317.918152 239.866745,370.563049 
	C229.502625,388.500397 208.072693,388.753784 197.714432,370.930969 
	C171.768997,326.288391 145.959198,281.567017 120.041695,236.546906 
	C124.374596,229.022644 128.871994,221.893692 133.123230,214.620865 
	C141.322021,200.594757 149.381729,186.487335 158.231110,172.232422 
	C181.407867,172.068420 203.852631,172.117828 226.297333,172.092514 
	C243.916473,172.072632 261.535522,171.960373 279.154602,171.889160 
z"/>
            <path fill="#013E45" opacity="1.000000" stroke="none"
                d="
M837.358582,205.455627 
	C838.440491,211.126984 839.074463,216.461823 840.565674,221.545166 
	C848.503967,248.604385 870.280518,266.132751 898.618896,269.042511 
	C918.305237,271.063873 937.436462,268.592194 956.909607,262.899200 
	C958.606689,272.217316 960.301147,281.454651 961.968323,290.696899 
	C963.205750,297.556976 964.186523,304.473022 965.710449,311.267975 
	C966.589050,315.185577 965.420898,316.875031 961.699280,318.140503 
	C941.409424,325.039703 920.409546,326.904755 899.226624,326.662537 
	C875.591736,326.392303 852.546143,322.562805 831.035950,312.102936 
	C794.140991,294.161896 773.713074,264.051422 767.014832,224.198456 
	C762.662048,198.300003 764.370728,172.643738 773.396667,147.906342 
	C788.853210,105.544411 820.152527,80.592926 862.838623,69.143440 
	C885.079407,63.177895 907.801270,61.056252 930.549805,66.125343 
	C947.388733,69.877594 959.707703,79.046844 962.556702,97.375488 
	C964.216003,108.049660 961.638672,118.117859 957.670227,127.775764 
	C948.746399,125.637733 940.145325,123.171951 931.386047,121.571388 
	C917.526184,119.038765 903.583191,118.660110 889.705688,121.879890 
	C861.230042,128.486618 841.818298,149.533813 838.214294,178.600204 
	C837.135010,187.304871 837.566772,196.196869 837.358582,205.455627 
z"/>
            <path fill="#013D44" opacity="1.000000" stroke="none"
                d="
M732.167358,278.000061 
	C732.167358,293.128632 732.167358,307.757172 732.167358,322.657654 
	C709.339783,322.657654 686.932983,322.657654 664.196167,322.657654 
	C664.196167,237.656342 664.196167,152.778809 664.196167,67.302757 
	C681.398193,67.966385 698.580566,67.355385 714.598267,74.884796 
	C726.683655,80.565742 731.806519,90.908722 731.945435,103.530762 
	C732.301147,135.854950 732.140320,168.184921 732.163574,200.512619 
	C732.182068,226.175079 732.167358,251.837555 732.167358,278.000061 
z"/>
            <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="
M1592.554810,275.583801 
	C1589.846069,275.374207 1588.058716,275.183044 1588.085938,271.942871 
	C1588.242432,253.299026 1588.169312,234.653290 1588.193359,216.008209 
	C1588.193970,215.542862 1588.415405,215.077774 1588.644531,214.176712 
	C1602.703369,214.072479 1616.828003,212.948898 1630.455444,217.933990 
	C1642.955200,222.506561 1649.740845,231.001083 1650.018677,242.296387 
	C1650.365356,256.396820 1644.382202,266.148529 1631.872314,271.538239 
	C1619.362061,276.928162 1606.157471,276.114349 1592.554810,275.583801 
z"/>
            <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="
M1610.062988,165.080322 
	C1602.657104,165.096619 1595.712036,165.096619 1588.463379,165.096619 
	C1588.463379,148.821671 1588.463379,132.642471 1588.463379,116.128113 
	C1601.544678,114.563179 1614.424927,113.337700 1627.175903,116.853813 
	C1638.054199,119.853539 1644.339111,126.983498 1645.038086,136.452988 
	C1645.858276,147.566437 1641.044067,156.193436 1630.236572,160.430099 
	C1624.016113,162.868561 1617.117310,163.576904 1610.062988,165.080322 
z"/>
            <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="
M279.069458,171.548203 
	C261.535522,171.960373 243.916473,172.072632 226.297333,172.092514 
	C203.852631,172.117828 181.407867,172.068420 158.497620,172.022324 
	C172.671143,146.533508 187.310089,121.073547 201.949265,95.613724 
	C207.326050,86.262634 212.703430,76.911896 218.208694,67.204453 
	C221.599442,72.242477 224.953934,77.583923 228.109314,83.040504 
	C245.094955,112.413635 262.031128,141.815369 279.069458,171.548203 
z"/>
            <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="
M1327.209106,233.652573 
	C1319.377808,206.442413 1319.126709,179.656448 1329.073730,153.411469 
	C1331.957031,145.803772 1336.430786,138.333374 1341.789307,132.213211 
	C1360.730713,110.579628 1393.567017,112.657349 1411.187744,136.022217 
	C1420.472534,148.333786 1424.795288,162.588013 1426.640259,177.589005 
	C1429.105591,197.632721 1427.866211,217.449173 1421.001587,236.643784 
	C1417.061035,247.662582 1411.136841,257.403473 1401.571655,264.474609 
	C1380.399536,280.126221 1350.036987,273.654785 1335.136963,250.134033 
	C1331.964966,245.126923 1329.902466,239.417099 1327.209106,233.652573 
z"/>
            <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="
M1094.200684,117.963570 
	C1114.539307,115.182602 1129.754639,122.782562 1140.749146,139.210083 
	C1149.489990,152.270081 1153.140747,167.051010 1154.463013,182.491241 
	C1156.071167,201.270187 1154.648315,219.736130 1148.003906,237.540909 
	C1143.851196,248.668915 1137.669922,258.422913 1127.703857,265.305145 
	C1107.902588,278.979126 1080.030396,273.886383 1065.005737,253.909882 
	C1056.473145,242.565155 1052.265259,229.469955 1050.342285,215.668915 
	C1047.555664,195.670074 1048.295776,175.780838 1055.079468,156.570602 
	C1057.326538,150.207153 1060.496826,144.020844 1064.149536,138.334549 
	C1071.088135,127.533165 1080.963501,120.505310 1094.200684,117.963570 
z"/>
        </svg>
    );
};
